

export const ApiPaths = {
    // version: `${process.env.REACT_APP_PUBLIC_URL === '/'? '': process.env.REACT_APP_PUBLIC_URL}/version.txt`,
    postFeedBack: '/api/requests',
    news: '/api/news-items',
}